import { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  LogoLoader,
  Placements,
  showToast,
  SmartTooltip,
  StatusTags,
  TableAdv,
} from "../../../../components";
//
import { useSelector, useDispatch } from "react-redux";
import {
  clearClientData,
  getClientsStart,
} from "../../../../redux/slices/client/clientSlice";
import { Link } from "react-router-dom";
import {
  getClientId,
  formatWords,
  getValueByKey,
  dateFormator,
  mapTableRows,
} from "../../../../utils";
import { usePagination } from "../../../../hooks";

const AllClients = () => {
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch();
  const { loading, error, clients, totalCount } = useSelector(
    (state) => state.client,
  );

  const isLoading = loading;

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      dispatch(
        getClientsStart({
          page: newPage,
          limit: newLimit,
          filter: {
            search: { type: "SEARCH", value: searchValue },
          },
          sort: { uiid: -1 },
          // sort: { uiid: 1 },
          ret: "uiid businessName generalInfo email contact placements jobCode recordStatus website",
          ref: "PlacementWithEmp",
          incl: "employeeId jobInfo.startDate jobInfo.endDate jobInfo.projectEndDate jobInfo.jobCode",
        }),
      );
    },
  );

  const tableData = clients?.data || []; // Add null check with default empty array
  const columns = [
    {
      key: "businessName",
      label: "Business Name",
      width: "min-w-[250px]! max-w-[350px]!",
      render: (row) => (
        <SmartTooltip
          description={row.businessName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="flex items-center gap-2 line-clamp-1!">
            {row.website && row.website !== "" ? (
              <a
                className="flex items-center gap-2 cursor-pointer"
                href={row.website}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Avatar alt={row.businessName} size="sm" outline />
                <span className="text-linkblue line-clamp-1!">{row.businessName}</span>
              </a>
            ) : (
              <>
                <Link to="/client/client-details" state={{ code: row.uiid }}>
                  <div className="flex items-center gap-2 cursor-pointer">
                    <Avatar alt={row.businessName} size="sm" outline />
                    <span className="text-linkblue line-clamp-1!">
                      {row.businessName}
                    </span>
                  </div>
                </Link>
              </>
            )}
          </div>
        </SmartTooltip>
      ),
    },
    {
      key: "",
      label: "Client ID",
      render: (row) => (
        <div className="flex items-center gap-1">
          <span className="text-linkblue">
            <Link to="/client/client-details" state={{ code: row.uiid }}>
              {getClientId(row.uiid)}
            </Link>
          </span>
        </div>
      ),
    },
    {
      key: "emailId",
      label: "Email ID",
      render: (row) => (
        <Link
          to="/client/client-details"
          state={{ code: row.uiid }}
          className="flex items-center gap-1 max-w-[300px]"
        >
          <p className="text-ellipsis text-linkblue">
            {row?.email?.join(", ")}
          </p>
        </Link>
      ),
    },
    {
      key: "phone",
      label: "Contact No",
      render: (row) => (
        <div className="flex items-center gap-1">
          <span className="">
            <Link to="/client/client-details" state={{ code: row.uiid }}>
              {/* <span className="text-linkblue"> */}
              {Array.isArray(row.phone) &&
                row.phone.map((phone, index) => (
                  <div key={index}>{phone.code + "-" + phone.number}</div>
                ))}

              {/* {row.contact?.code && row.contact?.number
              ? row.contact.code + "-" + row.contact.number
              : "-"} */}
            </Link>
          </span>
        </div>
      ),
    },
    {
      key: "netTerms",
      label: "Net Terms",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link to="/client/client-details" state={{ code: row.uiid }}>
            <span className="">
              {/* <span className="text-linkblue"> */}
              {row.generalInfo?.placementDetails?.recurring?.netTerms ||
                row.generalInfo?.placementDetails?.permanent?.netTerms ||
                "-"}
            </span>
          </Link>
        </div>
      ),
    },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        // <Link to="/client/client-details" state={{ code: row.uiid }}>
        <div className="flex items-center gap-1">
          <StatusTags
            tag={formatWords(
              "",
              getValueByKey(row.recordStatus, "RecordStatus"),
            )}
          />
        </div>
        // </Link>
      ),
    },

    {
      key: "placements",
      label: "Active Placements",
      render: (row) => (
        <Placements
          // data={row?.placements
          //   ?.filter((placement) => {
          //     const endDate = new Date(placement?.jobInfo?.endDate);
          //     const today = new Date();
          //     return !placement?.jobInfo?.endDate || endDate >= today;
          //   })
          //   .map((row) => {
          //     return {
          //       jobCode: row?.jobInfo?.jobCode,
          //       employeeName:
          //         row?.employeeId?.firstName +
          //           " " +
          //           row?.employeeId?.lastName || "-",
          //       employmentType:
          //         row?.employeeId?.employmentType === 1
          //           ? "Regular"
          //           : row?.employeeId?.employmentType === 2
          //           ? "Consultant"
          //           : row?.employeeId?.employmentType === 3
          //           ? "Contract"
          //           : "-" || "-",
          //       startDate: row?.jobInfo?.startDate || "-",
          //       endDate: row?.jobInfo?.endDate || "-",
          //     };
          //   })}
          data={Array.from(
            new Map(
              row?.placements
                ?.filter((placement) => {
                  const endDate = new Date(placement?.jobInfo?.endDate);
                  const today = new Date();
                  return !placement?.jobInfo?.endDate || endDate >= today;
                })
                .map((row) => [
                  row.uiid,
                  {
                    jobCode: row?.jobInfo?.jobCode,
                    employeeName:
                      row?.employeeId?.firstName +
                        " " +
                        row?.employeeId?.lastName || "-",
                    employmentType:
                      row?.employeeId?.employmentType === 1
                        ? "Regular"
                        : row?.employeeId?.employmentType === 2
                          ? "Consultant"
                          : row?.employeeId?.employmentType === 3
                            ? "Contract"
                            : "-" || "-",
                    startDate: row?.jobInfo?.startDate || "-",
                    endDate: row?.jobInfo?.endDate || "-",
                  },
                ]),
            ).values(),
          )}
          columnData={[
            // "id",
            {
              key: "jobCode",
              label: "Job Code",
              render: (row) => (
                <div className="flex items-center gap-1">
                  <span className="text-linkblue">{row.jobCode}</span>
                </div>
              ),
            },
            {
              key: "employeeName",
              label: "Employee Name",
              render: (row) => (
                <div className="flex items-center gap-1">
                  <span className="text-linkblue">{row.employeeName}</span>
                </div>
              ),
            },
            {
              key: "employmentType",
              label: "Employment Type",
              render: (row) => (
                <div className="flex items-center gap-1">
                  <span className="text-linkblue">{row.employmentType}</span>
                </div>
              ),
            },
            {
              key: "startDate",
              label: "Start Date",
              render: (row) => dateFormator(row.startDate, "month-day-year"),
            },
            {
              key: "endDate",
              label: "End Date",
              render: (row) => dateFormator(row.endDate, "month-day-year"),
            },
          ]}
          modalTitle="Active Placements"
        />
      ),
      // row.placements.length,
    },
    {
      key: "currency",
      label: "Currency",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link to="/client/client-details" state={{ code: row.uiid }}>
            <span className="">
              {row.generalInfo?.currencyType == 1
                ? "USD"
                : row.generalInfo?.currencyType == 2
                  ? "INR"
                  : "-" || "-"}
            </span>
          </Link>
        </div>
      ),
    },
  ];
  const mappedRows = mapTableRows(tableData, columns);

  useEffect(() => {
    dispatch(
      getClientsStart({
        page: page,
        limit: limit,
        filters: {
          search: {
            type: "SEARCH",
            value: searchValue,
          },
        },
        sort: { uiid: -1 },
        // sort: { uiid: 1 },
        ret: "uiid businessName generalInfo email phone placements jobCode recordStatus website",
        ref: "PlacementWithEmp",
        incl: "employeeId jobInfo.startDate jobInfo.endDate jobInfo.projectEndDate jobInfo.jobCode",
      }),
    );
    return () => {
      dispatch(clearClientData());
    };
  }, [dispatch, page, limit, searchValue]); // Empty array will cause it to run once when the component mounts
  const handleSearch = (keyname, value) => {
    setSearchValue(value);
  };
  return (
    <div className="flex flex-col overflow-hidden">
      <TableAdv
        tableId={`clients_allclients`}
        rows={mappedRows}
        columns={columns}
        showSlNo
        //
        serverPagination={true}
        totalCount={totalCount?.data}
        page={page}
        limit={limit}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        serverSerchValue={searchValue}
        serverOnSearch={handleSearch}
        toolbarRight={{
          search: true,
          filter: true,
          download: true,
        }}
      />
    </div>
  );
};

export default AllClients;
